import React, { memo } from 'react';
import { Panel, PanelHeader, PanelBody } from '../../../components/panel/panel.jsx';
import FormAppVersion from './components/FormAppVersion.js';

const AppVersionCreate = (props) => {
  return (
    <div>
      <h1 className="page-header">App Version Create</h1>
      <div className="row">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>Information</PanelHeader>
            <PanelBody>
              <FormAppVersion action="create" />
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
};

export default memo(AppVersionCreate);
